<template>
    <el-dialog
        class="add-order-sku"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Add Order SKU"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="addForm"
                :model="addForm"
                :rules="rules"
                label-width="100px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Shop" prop="shop_id" size="small">
                            <el-select
                                v-model="addForm.shop_id"
                                size="small"
                                clearable
                                filterable
                                placeholder="Placeholder Shop"
                            >
                                <el-option
                                    v-for="item in shopList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="SKU" prop="sku" size="small">
                            <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.sku"
                                    placeholder="Please input SKU"
                                ></el-input>
                        </el-form-item>
                        <el-form-item label="Goods Name" prop="name" size="small">
                            <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.name"
                                    placeholder="Please input Goods Name"
                                ></el-input>
                        </el-form-item>
                        <el-form-item label="Qty" prop="qty" size="small">
                            <el-input
                                    type="number"
                                    clearable
                                    size="small"
                                    v-model="addForm.qty"
                                    placeholder="Please input Qty"
                                ></el-input>
                        </el-form-item>
                        <el-form-item label="Price" prop="price" size="small">
                            <el-input
                                    clearable
                                    size="small"
                                    v-model="addForm.price"
                                    placeholder="Please input Price"
                                ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="addVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            addForm: {
                shop_id: "",
                sku: "",
                name: "",
                price: "",
                qty: "",
            },
            rules: {
                shop_id: [
                    {
                        required: true,
                        message: "Please input shop",
                    },
                ],
                sku: [
                    {
                        required: true,
                        message: "Please input sku",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "Please select goods name",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.addForm = {
                shop_id: "",
                sku: "",
                name: "",
                price: "",
                qty: "",
            };
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .shopOrderSku(
                            {
                                ...this.addForm,
                            },
                            "post",
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "新增成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
    },
    props: {
        addVisible: Boolean,
        tableItem: Object,
        funcName: String,
        shopList: () => Array,
    },
    watch: {
        addVisible(val) {
            if (val) {
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.add-order-sku {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
